import {
  dvPresetActions,
  DvToolbarAction,
  DvToolbarActionEvent,
} from '@devinco/ui/grid';
import { GridContext } from '../interfaces/grid-context';

export const vtPresetActions: {
  [key in 'excel' | 'reset' | 'fit' | 'reload']: DvToolbarAction;
} = {
  ...dvPresetActions,
  reload: {
    ...dvPresetActions.reload,
    clickFn: (event: DvToolbarActionEvent): void => {
      const gridContext = event.context as GridContext;
      const rowModelType = event.api.getGridOption('rowModelType');
      if (rowModelType === 'clientSide') {
        if (gridContext.treeDataConfig) {
          gridContext.reloadTreeData?.(event.api, gridContext);
        } else {
          gridContext.loadClientSideData?.(gridContext.extraFilter);
        }
      } else if (rowModelType === 'serverSide') {
        event.api.refreshServerSide({ route: [], purge: true });
      }
    },
  },
  excel: {
    ...dvPresetActions.excel,
    clickFn: ({ api, context }: DvToolbarActionEvent) => {
      api.exportDataAsExcel({
        fileName: `export-${context.entity?.toLowerCase() || 'file'}`,
      });
    },
  },
};

export const getStandardActionPreset = (): DvToolbarAction[] => {
  return [
    vtPresetActions.reset,
    vtPresetActions.fit,
    vtPresetActions.reload,
    vtPresetActions.excel,
  ];
};
